// authorize action types
export const AUTHORIZE_START = 'AUTHORIZE_START';
export const AUTHORIZE_SUCCESS = 'AUTHORIZE_SUCCESS';
export const AUTHORIZE_FAILURE = 'AUTHORIZE_FAILURE';
export const AUTHORIZE_LOGOUT = 'AUTHORIZE_LOGOUT';

// user profile action types 
export const USER_START = 'USER_START';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_FAILURE = 'USER_FAILURE';

// notifications action types 
export const NOTIFICATION_START = 'NOTIFICATION_START';
export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
export const NOTIFICATION_FAILURE = 'NOTIFICATION_FAILURE';

// local notices/messages to the user
export const NOTICE_SHOW = "NOTICE_SHOW";
export const NOTICE_HIDE = "NOTICE_HIDE";

// bread crumbs
export const BREADCRUM_SHOW = "BREADCRUM_SHOW";
export const BREADCRUM_UPDATE = "BREADCRUM_UPDATE";
// toolbar updates
export const TOOLBAR_STATE = "TOOLBAR_STATE";
export const TOOLBAR_UPDATE = "TOOLBAR_UPDATE";

// user personalization action types 
export const PERSONALIZATION_START = 'PERSONALIZATION_START';
export const PERSONALIZATION_SUCCESS = 'PERSONALIZATION_SUCCESS';
export const PERSONALIZATION_FAILURE = 'PERSONALIZATION_FAILURE';

// business clients (registered with exaspaces) 
export const BUSINESS_START = 'BUSINESS_START';
export const BUSINESS_SUCCESS = 'BUSINESS_SUCCESS';
export const BUSINESS_FAILURE = 'BUSINESS_FAILURE';

// business addons (system and client specific) 
export const ADDON_START = 'ADDON_START';
export const ADDON_SUCCESS = 'ADDON_SUCCESS';
export const ADDON_FAILURE = 'ADDON_FAILURE';

// business templates (system and client specific) 
export const TEMPLATE_START = 'TEMPLATE_START';
export const TEMPLATE_SUCCESS = 'TEMPLATE_SUCCESS';
export const TEMPLATE_FAILURE = 'TEMPLATE_FAILURE';
export const TEMPLATE_REMOVE = 'TEMPLATE_REMOVE';

export * from "common/store/types";